import React from "react";
import "./SubmitModal.css";
import Button from "../Button/Button";
import Modal from "../Modal/Modal";

const SubmitModal = ({
  isOpen,
  onClose,
  onSubmit,
  title,
  imageSrc,
  subtitle,
  totalQuestions,
  notAttempted,
  attempted,
  markedForReview,
  cancelButtonProps,
  submitButtonProps,
}) => {
  if (!isOpen) return null;

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="modal-content">
        <div className="modal-icon">
          <span className="upload-icon">
            <img src={imageSrc} alt="submit" />
          </span>
        </div>

        <h2 className="modal-title">{title}</h2>

        <p className="modal-subtitle">{subtitle}</p>

        <div className="modal-stats">
          <span>
            Total Questions:
            <span className="modal-stats-value"> {totalQuestions}</span>
          </span>
          <span>
            Not Attempted: <span className="modal-stats-value">{notAttempted}</span>
          </span>
          <span>
            Attempted: <span className="modal-stats-value">{attempted}</span>
          </span>
          <span>
            Marked for Review:
            <span className="modal-stats-value"> {markedForReview}</span>
          </span>
        </div>

        <div className="modal-actions">
          <Button {...cancelButtonProps} />
          <Button {...submitButtonProps} />
        </div>
      </div>
    </Modal>
  );
};

export default SubmitModal;